import { useState, useEffect } from 'react';
import FormUserList from '@IssueConsoleFunctionalDisplay/FormUserList';
import '@Partials/_SimpleStyles.scss';
import '@Partials/_ComStyles.scss';
import './PermissionsPage.scss';

export default function PermissionsPage(props) {

    const [kaiziqResolveConnection, setKaiziqResolveConnection] = useState({});
    const className = 'resolve__permissionsPage';

    useEffect(() => {
        setKaiziqResolveConnection(props.kaiziqResolveConnection);
    }, [props])

    return (
        <div className={className}>
            <div className={className + '__inner'}>
                {
                    kaiziqResolveConnection?.accessType === 'public_open' &&
                        <div className={className + '__inner__top '}>
                            <div className={className + '__inner__top__titleBar standard-text-large flex-row-center-1vw-gap width-wfa'}>
                                <div className={className + '__inner__top__titleBar__t1'}>
                                    Public:
                                </div>
                                <div className={className + '__inner__top__titleBar__t1'}>
                                    Open
                                </div>
                            </div>
                            <div className={className + '__inner__top__description'}>
                                A public form can be submitted by anyone with a link to the form.
                            </div>
                        </div>
                }
                {
                    kaiziqResolveConnection?.accessType === 'public_email' &&
                        <div className={className + '__inner__top '}>
                            <div className={className + '__inner__top__titleBar standard-text-large flex-row-center-1vw-gap width-wfa'}>
                                <div className={className + '__inner__top__titleBar__t1'}>
                                    Public:
                                </div>
                                <div className={className + '__inner__top__titleBar__t1'}>
                                    Email Verified
                                </div>
                            </div>
                            <div className={className + '__inner__top__description'}>
                                Your Users will have to verify using an OTP while submitting an issue.
                            </div>
                        </div>
                }
                {
                    kaiziqResolveConnection?.accessType === 'public_verified' &&
                        <div className={className + '__inner__top '}>
                            <div className={className + '__inner__top__titleBar standard-text-large flex-row-center-1vw-gap width-wfa'}>
                                <div className={className + '__inner__top__titleBar__t1'}>
                                    Public:
                                </div>
                                <div className={className + '__inner__top__titleBar__t1'}>
                                    Account Verified
                                </div>
                            </div>
                            <div className={className + '__inner__top__description'}>
                                Only Users that have a verified KaizIQ account are able to submit this form.
                            </div>
                        </div>
                }
                {
                    kaiziqResolveConnection?.accessType === 'private_email' &&
                        <div className={className + '__inner__top '}>
                            <div className={className + '__inner__top__titleBar standard-text-large flex-row-center-1vw-gap width-wfa'}>
                                <div className={className + '__inner__top__titleBar__t1'}>
                                    Private:
                                </div>
                                <div className={className + '__inner__top__titleBar__t1'}>
                                    Email Verified
                                </div>
                            </div>
                            <div className={className + '__inner__top__description'}>
                                You will have to give permissions to your User's emails. Your Users will have to verify using an OTP while submitting an issue.
                            </div>
                        </div>
                }
                {
                    kaiziqResolveConnection?.accessType === 'private_verified' &&
                        <div className={className + '__inner__top '}>
                            <div className={className + '__inner__top__titleBar standard-text-large flex-row-center-1vw-gap width-wfa'}>
                                <div className={className + '__inner__top__titleBar__t1'}>
                                    Private:
                                </div>
                                <div className={className + '__inner__top__titleBar__t1'}>
                                    Account Verified
                                </div>
                            </div>
                            <div className={className + '__inner__top__description'}>
                                Only Users that have a verified KaizIQ account and have been given permission by you, are able to submit this form.
                            </div>
                        </div>
                }
                <div className={className + '__inner__top__public__list'}>
                    <FormUserList
                        kaiziqResolveConnection={kaiziqResolveConnection}/>
                </div>
            </div>
        </div>
    );
}

